import ReactGA from "react-ga";
import { createBrowserHistory } from "history"; // eslint-disable-line

const history = createBrowserHistory();

const initialize = () => {
  ReactGA.initialize(`${googleAnalyticsId}`);
  ReactGA.set({ anonymizeIp: true });
};

const pageView = (location) => {
  ReactGA.set({ page: location.pathname });
  ReactGA.pageview(location.pathname);
};

if (env === "production") {
  initialize();
  pageView(window.location);

  history.listen((location) => {
    pageView(location);
  });
}

export default history;
